export default __webpack_public_path__ + "static/media/stadisticsFall.ea955572.svg";